import React from 'react'

export default function FooterLogo() {
  return (
    <svg
      viewBox='0 259.978 825.033 289.16'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <defs>
        <clipPath id='08e379c231'>
          <path
            d='M 113.132812 524.238281 L 143.132812 524.238281 L 143.132812 528.738281 L 113.132812 528.738281 Z M 113.132812 524.238281 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='5799cc953e'>
          <path
            d='M 13.511719 266.867188 L 289.511719 266.867188 L 289.511719 542.867188 L 13.511719 542.867188 Z M 13.511719 266.867188 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='1b1d05a9fc'>
          <path
            d='M 37.339844 288.40625 L 269.839844 288.40625 L 269.839844 520.90625 L 37.339844 520.90625 Z M 37.339844 288.40625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='b9eb9d846e'>
          <path
            d='M 72.148438 296.757812 L 128.398438 296.757812 L 128.398438 320.007812 L 72.148438 320.007812 Z M 72.148438 296.757812 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='d6cac58e8e'>
          <path
            d='M 81.296875 287.996094 L 153.296875 287.996094 L 153.296875 320.246094 L 81.296875 320.246094 Z M 81.296875 287.996094 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='46e0e57094'>
          <path
            d='M 59.386719 481.027344 L 128.386719 481.027344 L 128.386719 504.277344 L 59.386719 504.277344 Z M 59.386719 481.027344 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='8e75407422'>
          <path
            d='M 107.054688 489.070312 L 116.804688 489.070312 L 116.804688 499.570312 L 107.054688 499.570312 Z M 107.054688 489.070312 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='3d367df7ba'>
          <path
            d='M 59.386719 308.359375 L 114.886719 308.359375 L 114.886719 331.609375 L 59.386719 331.609375 Z M 59.386719 308.359375 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='c1bd505659'>
          <path
            d='M 151.339844 497.0625 L 157.339844 497.0625 L 157.339844 523.3125 L 151.339844 523.3125 Z M 151.339844 497.0625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='59493263a5'>
          <path
            d='M 151.339844 504.230469 L 157.339844 504.230469 L 157.339844 530.480469 L 151.339844 530.480469 Z M 151.339844 504.230469 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='5065ba4306'>
          <path
            d='M 153.171875 287.996094 L 157.671875 287.996094 L 157.671875 314.246094 L 153.171875 314.246094 Z M 153.171875 287.996094 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='6d9c97500e'>
          <path d='M 210 404 L 281 404 L 281 475 L 210 475 Z M 210 404 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='1fdd93213f'>
          <path
            d='M 246.355469 404.699219 L 280.824219 439.171875 L 245.292969 474.703125 L 210.824219 440.230469 Z M 246.355469 404.699219 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='ed1b5d26c6'>
          <path d='M 57 311 L 131 311 L 131 334 L 57 334 Z M 57 311 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='2ee45651a7'>
          <path
            d='M 57.507812 311.191406 L 130.257812 311.609375 L 130.128906 334.109375 L 57.378906 333.691406 Z M 57.507812 311.191406 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='e3d2856c79'>
          <path
            d='M 69.949219 295.34375 L 129.949219 295.34375 L 129.949219 321.59375 L 69.949219 321.59375 Z M 69.949219 295.34375 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='75a28a55ee'>
          <path
            d='M 79.011719 287.398438 L 130.011719 287.398438 L 130.011719 312.148438 L 79.011719 312.148438 Z M 79.011719 287.398438 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='b863b3798c'>
          <path
            d='M 58 307.164062 L 99.667969 307.164062 L 99.667969 326.664062 L 58 326.664062 Z M 58 307.164062 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='06dafcba68'>
          <path
            d='M 111.828125 274.140625 L 130.578125 274.140625 L 130.578125 298.890625 L 111.828125 298.890625 Z M 111.828125 274.140625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='11988ccf69'>
          <path d='M 153 273 L 158 273 L 158 317 L 153 317 Z M 153 273 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='de713b76b4'>
          <path
            d='M 153.207031 272.871094 L 157.707031 272.882812 L 157.589844 316.382812 L 153.089844 316.371094 Z M 153.207031 272.871094 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='f29e08b8eb'>
          <path d='M 154 287 L 159 287 L 159 332 L 154 332 Z M 154 287 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='40bb2f61d1'>
          <path
            d='M 154.871094 287.585938 L 158.621094 287.59375 L 158.507812 331.09375 L 154.757812 331.085938 Z M 154.871094 287.585938 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='ae04ef0693'>
          <path d='M 151 495 L 157 495 L 157 531 L 151 531 Z M 151 495 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='1ea8cfa129'>
          <path
            d='M 151.304688 495.6875 L 156.554688 495.71875 L 156.347656 530.96875 L 151.097656 530.9375 Z M 151.304688 495.6875 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='c86f2c9f76'>
          <path d='M 151 482 L 158 482 L 158 537 L 151 537 Z M 151 482 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='9b9aa69b38'>
          <path
            d='M 151.832031 482.722656 L 157.082031 482.734375 L 156.9375 536.734375 L 151.6875 536.722656 Z M 151.832031 482.722656 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='48ea4ff5c8'>
          <path
            d='M 57.667969 480.324219 L 128.917969 480.324219 L 128.917969 505 L 57.667969 505 Z M 57.667969 480.324219 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='f1f84bd345'>
          <path
            d='M 91.164062 504.230469 L 128.664062 504.230469 L 128.664062 528.230469 L 91.164062 528.230469 Z M 91.164062 504.230469 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='8c7bc3d9f2'>
          <path
            d='M 144.457031 521.140625 L 169.207031 521.140625 L 169.207031 534.640625 L 144.457031 534.640625 Z M 144.457031 521.140625 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='09ece552d3'>
          <path
            d='M 180.328125 439.582031 L 217.828125 439.582031 L 217.828125 524.332031 L 180.328125 524.332031 Z M 180.328125 439.582031 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='5618f0bc55'>
          <path d='M 179 492 L 218 492 L 218 525 L 179 525 Z M 179 492 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='e2296d5c7c'>
          <path
            d='M 180.3125 492.179688 L 217.8125 492.679688 L 217.390625 524.175781 L 179.890625 523.675781 Z M 180.3125 492.179688 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='cbe3b0158c'>
          <path d='M 203 402 L 283 402 L 283 483 L 203 483 Z M 203 402 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='6c6bc8fbf5'>
          <path
            d='M 203.089844 444.667969 L 244.988281 402.773438 L 282.640625 440.425781 L 240.742188 482.320312 Z M 203.089844 444.667969 '
            clipRule='nonzero'
          />
        </clipPath>
        <clipPath id='7a02230ef8'>
          <path d='M 203 450 L 255 450 L 255 510 L 203 510 Z M 203 450 ' clipRule='nonzero' />
        </clipPath>
        <clipPath id='5006117e90'>
          <path
            d='M 221.21875 450.800781 L 254.039062 463.652344 L 235.996094 509.746094 L 203.171875 496.894531 Z M 221.21875 450.800781 '
            clipRule='nonzero'
          />
        </clipPath>
      </defs>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(310.976697, 429.986279)'>
          <g>
            <path d='M 49.53125 -51.890625 L 49.53125 0 L 36.890625 0 L 36.890625 -21.359375 L 17.21875 -21.359375 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 L 17.21875 -51.890625 L 17.21875 -31.5625 L 36.890625 -31.5625 L 36.890625 -51.890625 Z M 49.53125 -51.890625 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(379.942213, 429.986279)'>
          <g>
            <path d='M 36.890625 -9.171875 L 17.515625 -9.171875 L 14.421875 0 L 1.1875 0 L 19.953125 -51.890625 L 34.59375 -51.890625 L 53.375 0 L 39.984375 0 Z M 33.640625 -18.921875 L 27.203125 -37.921875 L 20.84375 -18.921875 Z M 33.640625 -18.921875 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(449.351238, 429.986279)'>
          <g>
            <path d='M 2.4375 -26.015625 C 2.4375 -31.140625 3.546875 -35.707031 5.765625 -39.71875 C 7.984375 -43.738281 11.078125 -46.867188 15.046875 -49.109375 C 19.015625 -51.359375 23.507812 -52.484375 28.53125 -52.484375 C 34.695312 -52.484375 39.972656 -50.859375 44.359375 -47.609375 C 48.742188 -44.359375 51.675781 -39.921875 53.15625 -34.296875 L 39.25 -34.296875 C 38.21875 -36.460938 36.753906 -38.113281 34.859375 -39.25 C 32.960938 -40.382812 30.804688 -40.953125 28.390625 -40.953125 C 24.492188 -40.953125 21.335938 -39.597656 18.921875 -36.890625 C 16.503906 -34.179688 15.296875 -30.554688 15.296875 -26.015625 C 15.296875 -21.484375 16.503906 -17.863281 18.921875 -15.15625 C 21.335938 -12.445312 24.492188 -11.09375 28.390625 -11.09375 C 30.804688 -11.09375 32.960938 -11.65625 34.859375 -12.78125 C 36.753906 -13.914062 38.21875 -15.566406 39.25 -17.734375 L 53.15625 -17.734375 C 51.675781 -12.117188 48.742188 -7.695312 44.359375 -4.46875 C 39.972656 -1.238281 34.695312 0.375 28.53125 0.375 C 23.507812 0.375 19.015625 -0.742188 15.046875 -2.984375 C 11.078125 -5.234375 7.984375 -8.351562 5.765625 -12.34375 C 3.546875 -16.332031 2.4375 -20.890625 2.4375 -26.015625 Z M 2.4375 -26.015625 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(520.608161, 429.986279)'>
          <g>
            <path d='M 34.671875 0 L 17.21875 -22.921875 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 L 17.21875 -51.890625 L 17.21875 -29.125 L 34.515625 -51.890625 L 49.375 -51.890625 L 29.265625 -26.46875 L 50.125 0 Z M 34.671875 0 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(587.060544, 429.986279)'>
          <g>
            <path d='M 38.359375 -51.890625 L 38.359375 -41.765625 L 17.21875 -41.765625 L 17.21875 -30.828125 L 33.046875 -30.828125 L 33.046875 -21 L 17.21875 -21 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 Z M 38.359375 -51.890625 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(642.425466, 429.986279)'>
          <g>
            <path d='M 31.046875 0 L 20.25 -19.59375 L 17.21875 -19.59375 L 17.21875 0 L 4.578125 0 L 4.578125 -51.890625 L 25.796875 -51.890625 C 29.890625 -51.890625 33.375 -51.175781 36.25 -49.75 C 39.132812 -48.320312 41.289062 -46.363281 42.71875 -43.875 C 44.15625 -41.382812 44.875 -38.613281 44.875 -35.5625 C 44.875 -32.101562 43.898438 -29.019531 41.953125 -26.3125 C 40.003906 -23.601562 37.132812 -21.679688 33.34375 -20.546875 L 45.3125 0 Z M 17.21875 -28.53125 L 25.0625 -28.53125 C 27.375 -28.53125 29.109375 -29.097656 30.265625 -30.234375 C 31.429688 -31.367188 32.015625 -32.96875 32.015625 -35.03125 C 32.015625 -37.007812 31.429688 -38.5625 30.265625 -39.6875 C 29.109375 -40.820312 27.375 -41.390625 25.0625 -41.390625 L 17.21875 -41.390625 Z M 17.21875 -28.53125 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(705.551591, 429.986279)'>
          <g>
            <path d='M 17.21875 -41.765625 L 17.21875 -31.265625 L 34.15625 -31.265625 L 34.15625 -21.515625 L 17.21875 -21.515625 L 17.21875 -10.125 L 36.375 -10.125 L 36.375 0 L 4.578125 0 L 4.578125 -51.890625 L 36.375 -51.890625 L 36.375 -41.765625 Z M 17.21875 -41.765625 ' />
          </g>
        </g>
      </g>
      <g fill='#ffffff' fillOpacity='1'>
        <g transform='translate(760.473004, 429.986279)'>
          <g>
            <path d='M 17.21875 -41.765625 L 17.21875 -31.265625 L 34.15625 -31.265625 L 34.15625 -21.515625 L 17.21875 -21.515625 L 17.21875 -10.125 L 36.375 -10.125 L 36.375 0 L 4.578125 0 L 4.578125 -51.890625 L 36.375 -51.890625 L 36.375 -41.765625 Z M 17.21875 -41.765625 ' />
          </g>
        </g>
      </g>
      <g clipPath='url(#08e379c231)'>
        <g transform='matrix(0, -0.22319, 0.225852, 0, 112.302109, 537.658361)'>
          <image
            x='0'
            y='0'
            width='373'
            height='176'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXUAAACwCAIAAAB/zWksAAAABmJLR0QA/wD/AP+gvaeTAAACRklEQVR4nO3UQQ3AIADAQEAVyrHHVDQky52Cvjr3uQMgsF4HAL/lL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWo+AtQ8Reg4i9AxV+Air8AFX8BKv4CVPwFqPgLUPEXoOIvQMVfgIq/ABV/ASr+AlT8Baj4C1DxF6DiL0DFX4CKvwAVfwEq/gJU/AWofK1wA01UDs33AAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#5799cc953e)'>
        <path
          fill='#ffffff'
          d='M 289.511719 404.867188 C 289.511719 407.128906 289.457031 409.382812 289.34375 411.640625 C 289.234375 413.894531 289.066406 416.148438 288.847656 418.394531 C 288.625 420.644531 288.347656 422.882812 288.019531 425.117188 C 287.6875 427.351562 287.300781 429.574219 286.859375 431.792969 C 286.417969 434.007812 285.925781 436.210938 285.375 438.398438 C 284.828125 440.589844 284.222656 442.765625 283.570312 444.929688 C 282.914062 447.089844 282.207031 449.234375 281.445312 451.359375 C 280.683594 453.484375 279.871094 455.59375 279.007812 457.679688 C 278.140625 459.765625 277.226562 461.828125 276.261719 463.871094 C 275.296875 465.914062 274.28125 467.929688 273.214844 469.921875 C 272.152344 471.914062 271.039062 473.878906 269.878906 475.816406 C 268.714844 477.75 267.507812 479.660156 266.253906 481.539062 C 265 483.414062 263.699219 485.261719 262.355469 487.074219 C 261.007812 488.890625 259.621094 490.667969 258.1875 492.414062 C 256.753906 494.160156 255.277344 495.871094 253.761719 497.542969 C 252.246094 499.21875 250.6875 500.851562 249.09375 502.449219 C 247.496094 504.046875 245.859375 505.601562 244.1875 507.121094 C 242.511719 508.636719 240.804688 510.109375 239.058594 511.542969 C 237.3125 512.976562 235.53125 514.367188 233.71875 515.710938 C 231.902344 517.054688 230.058594 518.355469 228.179688 519.613281 C 226.300781 520.867188 224.394531 522.074219 222.457031 523.234375 C 220.519531 524.394531 218.554688 525.507812 216.5625 526.574219 C 214.570312 527.636719 212.554688 528.652344 210.515625 529.617188 C 208.472656 530.585938 206.40625 531.5 204.320312 532.363281 C 202.234375 533.226562 200.128906 534.039062 198.003906 534.800781 C 195.875 535.5625 193.730469 536.269531 191.570312 536.925781 C 189.410156 537.582031 187.234375 538.183594 185.042969 538.734375 C 182.851562 539.28125 180.648438 539.777344 178.433594 540.21875 C 176.21875 540.65625 173.992188 541.042969 171.761719 541.375 C 169.527344 541.707031 167.285156 541.984375 165.039062 542.203125 C 162.789062 542.425781 160.539062 542.589844 158.28125 542.703125 C 156.027344 542.8125 153.769531 542.867188 151.511719 542.867188 C 149.253906 542.867188 146.996094 542.8125 144.738281 542.703125 C 142.484375 542.589844 140.234375 542.425781 137.984375 542.203125 C 135.738281 541.984375 133.496094 541.707031 131.261719 541.375 C 129.027344 541.042969 126.804688 540.65625 124.589844 540.21875 C 122.375 539.777344 120.171875 539.28125 117.980469 538.734375 C 115.789062 538.183594 113.613281 537.582031 111.453125 536.925781 C 109.289062 536.269531 107.148438 535.5625 105.019531 534.800781 C 102.894531 534.039062 100.789062 533.226562 98.699219 532.363281 C 96.613281 531.5 94.550781 530.585938 92.507812 529.617188 C 90.46875 528.652344 88.449219 527.636719 86.457031 526.574219 C 84.464844 525.507812 82.503906 524.394531 80.566406 523.234375 C 78.628906 522.074219 76.71875 520.867188 74.84375 519.613281 C 72.964844 518.355469 71.117188 517.054688 69.304688 515.710938 C 67.492188 514.367188 65.710938 512.976562 63.964844 511.542969 C 62.21875 510.109375 60.507812 508.636719 58.835938 507.121094 C 57.164062 505.601562 55.527344 504.046875 53.929688 502.449219 C 52.332031 500.851562 50.777344 499.21875 49.261719 497.542969 C 47.742188 495.871094 46.269531 494.160156 44.835938 492.414062 C 43.402344 490.667969 42.015625 488.890625 40.667969 487.074219 C 39.324219 485.261719 38.023438 483.414062 36.769531 481.539062 C 35.515625 479.660156 34.304688 477.75 33.144531 475.816406 C 31.984375 473.878906 30.871094 471.914062 29.804688 469.921875 C 28.742188 467.929688 27.726562 465.914062 26.761719 463.871094 C 25.796875 461.828125 24.878906 459.765625 24.015625 457.679688 C 23.152344 455.59375 22.339844 453.484375 21.578125 451.359375 C 20.816406 449.234375 20.109375 447.089844 19.453125 444.929688 C 18.796875 442.765625 18.195312 440.589844 17.648438 438.398438 C 17.097656 436.210938 16.601562 434.007812 16.164062 431.792969 C 15.722656 429.574219 15.335938 427.351562 15.003906 425.117188 C 14.671875 422.882812 14.398438 420.644531 14.175781 418.394531 C 13.953125 416.148438 13.789062 413.894531 13.675781 411.640625 C 13.566406 409.382812 13.511719 407.128906 13.511719 404.867188 C 13.511719 402.609375 13.566406 400.351562 13.675781 398.097656 C 13.789062 395.839844 13.953125 393.589844 14.175781 391.34375 C 14.398438 389.09375 14.671875 386.855469 15.003906 384.621094 C 15.335938 382.386719 15.722656 380.160156 16.164062 377.945312 C 16.601562 375.730469 17.097656 373.527344 17.648438 371.335938 C 18.195312 369.148438 18.796875 366.96875 19.453125 364.808594 C 20.109375 362.648438 20.816406 360.503906 21.578125 358.378906 C 22.339844 356.25 23.152344 354.144531 24.015625 352.058594 C 24.878906 349.972656 25.796875 347.90625 26.761719 345.867188 C 27.726562 343.824219 28.742188 341.808594 29.804688 339.816406 C 30.871094 337.824219 31.984375 335.859375 33.144531 333.921875 C 34.304688 331.984375 35.515625 330.078125 36.769531 328.199219 C 38.023438 326.320312 39.324219 324.476562 40.667969 322.664062 C 42.015625 320.847656 43.402344 319.066406 44.835938 317.324219 C 46.269531 315.578125 47.742188 313.867188 49.261719 312.195312 C 50.777344 310.519531 52.332031 308.886719 53.929688 307.289062 C 55.527344 305.691406 57.164062 304.132812 58.835938 302.617188 C 60.507812 301.101562 62.21875 299.625 63.964844 298.191406 C 65.710938 296.761719 67.492188 295.371094 69.304688 294.027344 C 71.117188 292.679688 72.964844 291.378906 74.84375 290.125 C 76.71875 288.871094 78.628906 287.664062 80.566406 286.503906 C 82.503906 285.339844 84.464844 284.226562 86.457031 283.164062 C 88.449219 282.097656 90.46875 281.082031 92.507812 280.117188 C 94.550781 279.152344 96.613281 278.238281 98.699219 277.375 C 100.789062 276.507812 102.894531 275.695312 105.019531 274.9375 C 107.148438 274.175781 109.289062 273.464844 111.453125 272.8125 C 113.613281 272.15625 115.789062 271.554688 117.980469 271.003906 C 120.171875 270.457031 122.375 269.960938 124.589844 269.519531 C 126.804688 269.078125 129.027344 268.695312 131.261719 268.363281 C 133.496094 268.03125 135.738281 267.753906 137.984375 267.53125 C 140.234375 267.3125 142.484375 267.144531 144.738281 267.035156 C 146.996094 266.925781 149.253906 266.867188 151.511719 266.867188 C 153.769531 266.867188 156.027344 266.925781 158.28125 267.035156 C 160.539062 267.144531 162.789062 267.3125 165.039062 267.53125 C 167.285156 267.753906 169.527344 268.03125 171.761719 268.363281 C 173.992188 268.695312 176.21875 269.078125 178.433594 269.519531 C 180.648438 269.960938 182.851562 270.457031 185.042969 271.003906 C 187.234375 271.554688 189.410156 272.15625 191.570312 272.8125 C 193.730469 273.464844 195.875 274.175781 198.003906 274.9375 C 200.128906 275.695312 202.234375 276.507812 204.320312 277.375 C 206.40625 278.238281 208.472656 279.152344 210.515625 280.117188 C 212.554688 281.082031 214.570312 282.097656 216.5625 283.164062 C 218.554688 284.226562 220.519531 285.339844 222.457031 286.503906 C 224.394531 287.664062 226.300781 288.871094 228.179688 290.125 C 230.058594 291.378906 231.902344 292.679688 233.71875 294.027344 C 235.53125 295.371094 237.3125 296.761719 239.058594 298.191406 C 240.804688 299.625 242.511719 301.101562 244.1875 302.617188 C 245.859375 304.132812 247.496094 305.691406 249.09375 307.289062 C 250.6875 308.886719 252.246094 310.519531 253.761719 312.195312 C 255.277344 313.867188 256.753906 315.578125 258.1875 317.324219 C 259.621094 319.066406 261.007812 320.847656 262.355469 322.664062 C 263.699219 324.476562 265 326.320312 266.253906 328.199219 C 267.507812 330.078125 268.714844 331.984375 269.878906 333.921875 C 271.039062 335.859375 272.152344 337.824219 273.214844 339.816406 C 274.28125 341.808594 275.296875 343.824219 276.261719 345.867188 C 277.226562 347.90625 278.140625 349.972656 279.007812 352.058594 C 279.871094 354.144531 280.683594 356.25 281.445312 358.378906 C 282.207031 360.503906 282.914062 362.648438 283.570312 364.808594 C 284.222656 366.96875 284.828125 369.148438 285.375 371.335938 C 285.925781 373.527344 286.417969 375.730469 286.859375 377.945312 C 287.300781 380.160156 287.6875 382.386719 288.019531 384.621094 C 288.347656 386.855469 288.625 389.09375 288.847656 391.34375 C 289.066406 393.589844 289.234375 395.839844 289.34375 398.097656 C 289.457031 400.351562 289.511719 402.609375 289.511719 404.867188 Z M 289.511719 404.867188 '
          fillOpacity='1'
          fillRule='nonzero'
        />
      </g>
      <g clipPath='url(#1b1d05a9fc)'>
        <path
          fill='#1155cc'
          d='M 153.628906 288.40625 C 89.378906 288.40625 37.339844 340.445312 37.339844 404.695312 C 37.339844 468.949219 89.378906 520.988281 153.628906 520.988281 C 217.882812 520.988281 269.921875 468.949219 269.921875 404.695312 C 269.921875 340.445312 217.882812 288.40625 153.628906 288.40625 Z M 153.628906 497.730469 C 102.230469 497.730469 60.597656 456.097656 60.597656 404.695312 C 60.597656 353.296875 102.230469 311.664062 153.628906 311.664062 C 205.03125 311.664062 246.664062 353.296875 246.664062 404.695312 C 246.664062 456.097656 205.03125 497.730469 153.628906 497.730469 Z M 153.628906 497.730469 '
          fillOpacity='1'
          fillRule='nonzero'
        />
      </g>
      <path
        strokeLinecap='butt'
        transform='matrix(0.75, 0, 0, 0.75, 57.668315887451165, 393.447998046875)'
        fill='none'
        strokeLinejoin='miter'
        d='M -0.000460598 15.001615 L 227.676634 15.001615 '
        stroke='#1155cc'
        strokeWidth='30'
        strokeOpacity='1'
        strokeMiterlimit='4'
      />
      <g clipPath='url(#b9eb9d846e)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 25.166772, 263.030397)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#d6cac58e8e)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 25.166772, 257.099832)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#46e0e57094)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 12.405091, 447.301869)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <path
        strokeLinecap='butt'
        transform='matrix(-0.007659009657800198, 0.7499610185623169, -0.7499610185623169, -0.007659009657800198, 153.2740020751953, 288.11322021484375)'
        fill='none'
        strokeLinejoin='miter'
        d='M 0.00225094 15.001522 L 310.383019 14.998576 '
        stroke='#1155cc'
        strokeWidth='30'
        strokeOpacity='1'
        strokeMiterlimit='4'
      />
      <path
        strokeLinecap='butt'
        transform='matrix(-0.002380690071731806, 0.7499960064888, -0.7499960064888, -0.002380690071731806, 180.68504333496094, 304.435791015625)'
        fill='none'
        strokeLinejoin='miter'
        d='M -0.00217714 15.002016 L 288.551356 14.997532 '
        stroke='#1155cc'
        strokeWidth='30'
        strokeOpacity='1'
        strokeMiterlimit='4'
      />
      <g clipPath='url(#8e75407422)'>
        <g transform='matrix(0.445755, 0, 0, 0.438202, 84.972275, 478.725812)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#3d367df7ba)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 10.686229, 274.630782)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#c1bd505659)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 104.358601, 463.336629)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#59493263a5)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 101.818328, 470.502644)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#5065ba4306)'>
        <g transform='matrix(1.443396, 0, 0, 1.441011, 106.076981, 254.269226)'>
          <image
            x='0'
            y='0'
            width='106'
            height='89'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#6d9c97500e)'>
        <g clipPath='url(#1fdd93213f)'>
          <g transform='matrix(1.20575, 1.20575, -1.20367, 1.20367, 257.554327, 300.198569)'>
            <image
              x='0'
              y='0'
              width='106'
              height='89'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGoAAABZCAIAAABZrSbDAAAABmJLR0QA/wD/AP+gvaeTAAABNUlEQVR4nO3UW06DUBRAUTCdgINz1o6p+EFDH0CN7o9qWPuPcy7JzUpgfP/4HPTb3l59gf8dvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL4UvhS+FL7U6dUX+ONNz9f4bvsGax2+uR/DzR2cb1/tYTNunzoy35bdPBuvXjtul47Jt4K7UXvq9fji0fh24bbU1h/wOAzDMF3nR+O7b1rDLTTjSu+8bJYOxTc9Pt3ZTXdHxvPN7jJd/w+/ALvEGvHGydzwAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#ed1b5d26c6)'>
        <g clipPath='url(#2ee45651a7)'>
          <g transform='matrix(0.507614, 0.00291914, -0.00293522, 0.510408, 53.208069, 297.231528)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#e3d2856c79)'>
        <g transform='matrix(0.457317, 0, 0, 0.458333, 67.833713, 288.905161)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#75a28a55ee)'>
        <g transform='matrix(0.503049, 0, 0, 0.5, 79.010625, 278.049084)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#b863b3798c)'>
        <g transform='matrix(0.407012, 0, 0, 0.40625, 57.668314, 299.55522)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#06dafcba68)'>
        <g transform='matrix(0.503049, 0, 0, 0.5, 79.010618, 264.793304)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#11988ccf69)'>
        <g clipPath='url(#de713b76b4)'>
          <g transform='matrix(0.644815, 0.00170923, -0.00171193, 0.645831, 92.736985, 272.711183)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#f29e08b8eb)'>
        <g clipPath='url(#40bb2f61d1)'>
          <g transform='matrix(0.644815, 0.00170923, -0.00171193, 0.645831, 93.127594, 287.421142)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#ae04ef0693)'>
        <g clipPath='url(#1ea8cfa129)'>
          <g transform='matrix(0.919192, 0.0053138, -0.00529911, 0.916651, 60.207496, 495.162405)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#c86f2c9f76)'>
        <g clipPath='url(#9b9aa69b38)'>
          <g transform='matrix(0.919204, 0.00243657, -0.00242983, 0.916663, 65.336998, 482.491815)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#48ea4ff5c8)'>
        <g transform='matrix(0.448171, 0, 0, 0.447917, 57.088676, 472.7135)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#f1f84bd345)'>
        <g transform='matrix(0.589939, 0, 0, 0.59375, 32.077374, 489.611415)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#8c7bc3d9f2)'>
        <g transform='matrix(0.448171, 0, 0, 0.447917, 97.411748, 502.280803)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#09ece552d3)'>
        <g transform='matrix(1.577744, 0, 0, 1.583333, 130.486315, 412.648247)'>
          <image
            x='0'
            y='0'
            width='164'
            height='72'
            preserveAspectRatio='xMidYMid meet'
            xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
          />
        </g>
      </g>
      <g clipPath='url(#5618f0bc55)'>
        <g clipPath='url(#e2296d5c7c)'>
          <g transform='matrix(1.577603, 0.0211117, -0.0211865, 1.583192, 130.836176, 464.578888)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#cbe3b0158c)'>
        <g clipPath='url(#6c6bc8fbf5)'>
          <g transform='matrix(1.115633, -1.115633, 1.119586, 1.119586, 165.56437, 447.629582)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
      <g clipPath='url(#7a02230ef8)'>
        <g clipPath='url(#5006117e90)'>
          <g transform='matrix(1.366956, 0.535182, -0.53546, 1.367666, 187.236014, 410.63734)'>
            <image
              x='0'
              y='0'
              width='164'
              height='72'
              preserveAspectRatio='xMidYMid meet'
              xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKQAAABICAIAAAD3UcnvAAAABmJLR0QA/wD/AP+gvaeTAAAAwElEQVR4nO3RQQ0AIBDAMMC/58MFPNYqWLI9M4uG8zuAd8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvE7BCzQ8wOMTvkAvaBA42ylWMVAAAAAElFTkSuQmCC'
            />
          </g>
        </g>
      </g>
    </svg>
  )
}
